import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { baseAPI } from '~shared/api/base-api';
import { QUERY_KEYS } from '~shared/api/query-keys';

import type { Group } from '../modal/group';

export interface EditGroupParams {
  fieldId: string;
  fieldName: string;
}

export const updateGroupAPI = async ({
  fieldId,
  fieldName,
}: EditGroupParams) => {
  const resp = await baseAPI.patch<Group>(`/custom-form/${fieldId}`, {
    fieldName,
    fieldId,
    fieldType: 'group',
  });
  return resp.data;
};

export const useUpdateGroupMutation = () => {
  return useMutation({
    mutationFn: async (params: EditGroupParams) => {
      const response = await updateGroupAPI(params);
      return response;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: QUERY_KEYS.GROUPS,
      });
    },
  });
};
